import { makeStyles } from '@material-ui/core';

const styles = makeStyles({
    sidebarContainer: ({ isOpen, rtl }) => ({
        width: isOpen ? '254px' : '64px',
        height: '100vh',
        position: 'sticky',
        top: '-60px',
        margin: rtl ? '-60px -40px -40px 40px' : '-60px 40px -40px -40px',
        bottom: '0',
        overflowY: 'auto',
        overflowX: 'hidden',
        transition: 'all 0.3s ease',
        background: '#fff',
        whiteSpace: 'nowrap',
        display: 'flex',
        flexFlow: 'column',
        borderTopLeftRadius: rtl ? '15px' : 'unset',
        borderTopRightRadius: rtl ? 'unset' : '15px'
    }),

    closeSection: () => ({
        fontSize: '13px',
        fontFamily: 'mainFont',
        color: '#6c6e73',
        display: 'flex',
        margin: '40px 20px',
        flex: '1',
        alignItems: 'flex-end',
        // padding: '0 11px',
        '& div > img': {
            width: '20px',
            height: '20px',
            transform: ({ rtl, isOpen }) =>
                rtl && !isOpen ? 'rotateY(180deg)' : !rtl && isOpen && 'rotateY(180deg)'
            // margin: '0 15px'
        },
        '& > *': {
            display: 'flex',
            cursor: 'pointer',
            alignItems: 'center'
            // flexDirection: props.rtl ? 'row' : 'row-reverse'
        }
    }),
    // openMenuIcon: {
    //     transform: (props) => props.rtl && 'rotateY(180deg)'
    // },
    closeMenuMessage: {
        fontFamily: 'inherit',
        fontSize: '13px',
        fontWeight: 'bold',
        color: '#545e66',
        margin: '0 5px'
    },
    patientSection: ({ isOpen, rtl }) => ({
        fontFamily: 'inherit',
        fontSize: '15px',
        margin:
            !isOpen && rtl
                ? '0px 10px 0px 20px'
                : !isOpen && !rtl
                ? '0px 20px 0px 10px'
                : '0px 27px 0px 12px',
        padding: '40px 0 17px 0px',
        color: '#3d454a',
        lineHeight: '1.73',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row-reverse',
        visibility: isOpen ? 'visible' : 'hidden',
        borderBottom: '1.5px solid rgba(206, 210, 214, 0.6)',
        '& > div': {
            minHeight: '1.73em'
        }
    }),
    titleWrapper: ({ isOpen }) => ({
        padding: '40px 0 17px 0px',
        borderBottom: '1.5px solid rgba(206, 210, 214, 0.6)',
        visibility: isOpen ? 'visible' : 'hidden',
        margin: '0 20px'
    }),
    title: {
        padding: '0px 16px'
    },
    closeIcon: {
        visibility: 'visible',
        cursor: 'pointer'
    },
    closeIconWrapper: {
        width: '20px',
        height: '20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    patientAge: () => ({
        display: 'flex',
        alignItems: 'center',
        paddingTop: '7px',
        // justifyContent: 'space-between',
        '& div div:last-child': {
            marginRight: '2px'
        },
        '& div span': {
            minWidth: '30px'
        },
        '& > img': {
            marginInlineEnd: '4px'
        }
    }),
    linksContainer: ({ isOpen }) => ({
        fontSize: '13px',
        color: '#3d454a',
        // height: 'calc(100% - 150px)',
        // overflow: 'auto',
        direction: 'inherit',
        paddingInlineStart: isOpen ? '16px' : '12px',
        paddingInlineEnd: isOpen ? '12px' : '0',
        marginTop: '13px'
    }),
    linkItemContainer: ({ rtl }) => ({
        // borderBottom: '1px solid #d8d8d8',
        lineHeight: rtl ? '38px' : '34px',
        position: 'relative',
        marginBottom: '13px'
    }),
    link: ({ isOpen, rtl }) => ({
        padding: '8px 16px',
        paddingInlineStart: isOpen ? '16px' : '8px',
        // width: '100%',
        display: 'flex',
        alignItems: 'center',
        fontFamily: 'inherit',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.69,
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#232733',

        borderRadius: isOpen ? '5px' : rtl ? '0 5px 5px 0' : '5px 0 0 5px',
        '& > img': {
            marginInlineEnd: '12px'
        },
        '&:hover': {
            background: 'rgba(80, 159, 250, 0.16)'
        }
    }),
    activeLink: () => ({
        background: 'rgba(80, 159, 250, 0.16)'
    }),
    activeLinkContainer: {
        fontWeight: 'bold',
        position: 'relative'
    },
    linkLabel: ({ isOpen }) => ({
        visibility: isOpen ? 'visible' : 'hidden'
    }),
    optionWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& svg': {
            cursor: 'pointer'
        }
    }
});

export default styles;
